throw "Do not require hanzi-writer-data directly. You should instead require each character you want to use, like: var char = require('hanzi-writer-data/我')";